import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT} from "../constants/property_card_detail_info_table_content";
import {IVariable} from "../types/IVariable";
import {getAdditionalAreasName} from "../types/property/AdditionalAreasType";
import {IPropertyDetailDTO} from "../types/property/IPropertyDetailDTO";

export const PROPERTY_CARD_DETAIL_INFO_TABLE_ICON_PROPS = {
    fill: "var(--colors-gray-700)",
    size: "2.4",
    wrapperSize: "2.4"
} as const;

export function getPropertyCardDetailAdditionalAreasValue(additionalAreas: IPropertyDetailDTO["additional_areas"]): string | undefined {
    if (!additionalAreas?.length) return undefined;

    const labels = additionalAreas
        .map((item) => getAdditionalAreasName(item.type))
        .filter(Boolean)
        .join(", ");

    return labels || undefined;
}

export function getPropertyCardDetailConstructionDate(builtDate: string, today: string): string {
    if (builtDate >= today) return formatDate(builtDate, dateTimeFormat.quarter);

    return PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.CONSTRUCTION_READY;
}

export function getPropertyCardDetailFloorValue(floor: number | null): number | string {
    if (floor === 0 || floor == null) return PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.GROUND_FLOOR;

    return floor;
}

export function getPropertyCardDetailQuarterLabels(quarters: number[] | undefined, quarterTypes: IVariable[]): string | undefined {
    if (!quarters?.length) return undefined;

    const labels = quarters
        .map((quarter) => quarterTypes.find((quarterType) => quarterType.value === quarter)?.label)
        .filter(Boolean)
        .join(", ")
        .toLowerCase();

    return labels || undefined;
}
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT} from "../constants/property_card_detail_info_table_content";
import {IVariable} from "../types/IVariable";
import {getAdditionalAreasName} from "../types/property/AdditionalAreasType";
import {IPropertyDetailDTO} from "../types/property/IPropertyDetailDTO";

export const PROPERTY_CARD_DETAIL_INFO_TABLE_ICON_PROPS = {
    fill: "var(--colors-gray-700)",
    size: "2.4",
    wrapperSize: "2.4"
} as const;

export function getPropertyCardDetailAdditionalAreasValue(additionalAreas: IPropertyDetailDTO["additional_areas"]): string | undefined {
    if (!additionalAreas?.length) return undefined;

    const labels = additionalAreas
        .map((item) => getAdditionalAreasName(item.type))
        .filter(Boolean)
        .join(", ");

    return labels || undefined;
}

export function getPropertyCardDetailConstructionDate(builtDate: string, today: string): string {
    if (builtDate >= today) return formatDate(builtDate, dateTimeFormat.quarter);

    return PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.CONSTRUCTION_READY;
}

export function getPropertyCardDetailFloorValue(floor: number | null): number | string {
    if (floor === 0 || floor == null) return PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.GROUND_FLOOR;

    return floor;
}

export function getPropertyCardDetailQuarterLabels(quarters: number[] | undefined, quarterTypes: IVariable[]): string | undefined {
    if (!quarters?.length) return undefined;

    const labels = quarters
        .map((quarter) => quarterTypes.find((quarterType) => quarterType.value === quarter)?.label)
        .filter(Boolean)
        .join(", ")
        .toLowerCase();

    return labels || undefined;
}
